import React from 'react';
import '../../styles/Audiencias.css';
import CountUp from "react-countup";


const Audience = () => {
    return (
        <section className="audience-section pb-5">
            <div className='container'>
            {/* Título */}
            <div className="title-container"  data-aos="fade-up">
                <h2 className="title">Audiencias</h2>
                <div className="title-underline"></div>
            </div>

            <div className="section-description" data-aos="fade-up">
                <p>
                    Alcanzamos a miles de usuarios de habla hispana cada mes. Los datos respaldan nuestra capacidad para conectar 
                    de manera efectiva con audiencias clave, generando interacciones significativas entre el público y nuestros clientes.
                </p>
            </div>

            {/* Contenido principal desktop*/}
            <div className="audience-container desktop-section">
                <div className='row text-center justify-content-center'>
                    <div className='col-md-3 col-12 mt-5' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-end align-items-center'>
                            <div>
                                <h4>Páginas vistas</h4>
                                <p>
                                    +<CountUp start={0} end={2} duration={10} separator="," />,2M
                                </p>
                            </div>
                            <img src="assets/audiencia_7.png" alt="paginas visitadas" className='img-fluid' />
                        </div>
                    </div>
                    <div className='col-md-3 col-12' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_9.png" alt="usuarios unicos" className='img-fluid' />
                            <div>
                                <h4>Usuarios únicos</h4>
                                <p>
                                    +<CountUp start={0} end={1} duration={10} separator="," />,2M
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-3 col-12 mt-5' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_8.png" alt="seguidores rrss" className='img-fluid' />
                            <div>
                                <h4>Seguidores RRSS</h4>
                                <p>
                                    +<CountUp start={0} end={101} duration={10} separator="," />K
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row text-center align-items-center justify-content-center'>
                    <div className='col-md-3 col-12' data-aos="fade-right" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-end align-items-center'>
                            <div>
                                <h4>Facebook</h4>
                                <p>
                                    <CountUp start={0} end={76} duration={10} separator="," />K
                                </p>
                            </div>
                            <img src="assets/audiencia_1.png" alt="facebook" className='img-fluid' />
                        </div>
                        <div className='d-flex justify-content-end align-items-center mt-5' data-aos="fade-right" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                            <div>
                                <h4>X</h4>
                                <p>
                                    <CountUp start={0} end={192} duration={10} separator="," />
                                </p>
                            </div>
                            <img src="assets/audiencia_2.png" alt="x" className='img-fluid' />
                        </div>
                    </div>

                    <div className='audience-central-logo-border col-md-4 d-grid justify-content-center align-items-center' data-aos="zoom-in-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-center align-items-center audience-central-logo-container'>
                            <img src="assets/audiencia_centro.png" alt="logo behealth" className='img-fluid' />
                        </div>
                    </div>

                    <div className='col-md-3 col-12'>
                        <div className='d-flex justify-content-left align-items-center' data-aos="fade-left" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                            <img src="assets/audiencia_3.png" alt="audiencia" className='img-fluid' />
                            <div>
                                <h4>Instagram</h4>
                                <p>
                                    <CountUp start={0} end={13300} duration={10} separator="," />
                                </p>
                            </div>
                        </div>
                        <div className='d-flex justify-content-left align-items-center  mt-5' data-aos="fade-left" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                            <img src="assets/audiencia_6.png" alt="linkedin" className='img-fluid' />
                            <div>
                                <h4>LinkedIn</h4>
                                <p>
                                    <CountUp start={0} end={1000} duration={10} separator="," />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row text-center justify-content-center'>
                    <div className='col-md-3 col-12' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-end align-items-center'>
                            <div>
                                <h4>Youtube</h4>
                                <p>
                                    <CountUp start={0} end={7711} duration={10} separator="," />
                                </p>
                            </div>
                            <img src="assets/audiencia_4.png" alt="youtube" className='img-fluid' />
                        </div>
                    </div>
                    <div className='col-md-3 col-12' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_5.png" alt="tiktok" className='img-fluid' />
                            <div>
                                <h4>TikTok</h4>
                                <p>
                                    <CountUp start={0} end={3495} duration={10} separator="," />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* Contenido principal mobile*/}
            <div className='mobile-section audience-container'>
                <div className='row justify-content-center align-items-center'>
                    <div className='col-12 col-md-6' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_7.png" alt="" className='img-fluid' />
                            <div>
                                <h4>Páginas vistas</h4>
                                <p>
                                    +<CountUp start={0} end={2} duration={10} separator="," />,2M
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-md-6' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_9.png" alt="" className='img-fluid' />
                            <div>
                                <h4>Usuarios únicos</h4>
                                <p>
                                    +<CountUp start={0} end={1} duration={10} separator="," />,2M
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-md-6' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_8.png" alt="" className='img-fluid' />
                            <div>
                                <h4>Seguidores RRSS</h4>
                                <p>
                                    +<CountUp start={0} end={101} duration={10} separator="," />K
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-md-6' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_1.png" alt="" className='img-fluid' />
                            <div>
                                <h4>Facebook</h4>
                                <p>
                                    <CountUp start={0} end={76} duration={10} separator="," />K
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='audience-central-logo-border col-md-12 d-grid justify-content-center align-items-center' data-aos="zoom-in-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-center align-items-center audience-central-logo-container'>
                            <img src="assets/audiencia_centro.png" alt="" className='img-fluid' />
                        </div>
                    </div>

                    <div className='col-12 col-md-6' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_2.png" alt="" className='img-fluid' />
                            <div>
                                <h4>X</h4>
                                <p>
                                    <CountUp start={0} end={192} duration={10} separator="," />
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-md-6' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_3.png" alt="" className='img-fluid' />
                            <div>
                                <h4>Instagram</h4>
                                <p><CountUp start={0} end={13332} duration={10} separator="," /></p>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-md-6' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_6.png" alt="" className='img-fluid' />
                            <div>
                                <h4>LinkedIn</h4>
                                <p><CountUp start={0} end={1000} duration={10} separator="," /></p>
                            </div>
                        </div>
                    </div>

                    <div className='col-12 col-md-6' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>

                            <img src="assets/audiencia_4.png" alt="" className='img-fluid' />
                            <div>
                                <h4>Youtube</h4>
                                <p>
                                    <CountUp start={0} end={7711} duration={10} separator="," />
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-md-6' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="3000">
                        <div className='d-flex justify-content-left align-items-center'>
                            <img src="assets/audiencia_5.png" alt="" className='img-fluid' />
                            <div>
                                <h4>TikTok</h4>
                                <p>
                                    <CountUp start={0} end={3495} duration={10} separator="," />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
    );
};

export default Audience;